import React from 'react';
import PropTypes from 'prop-types';
import { View, useWindowDimensions } from 'react-native-web';

import { Button } from '../../../../shared-components/base-components';
import { useSelectedParams } from '../../../../hooks';
import { DaysOfWeek } from '../../../../shared/days-of-week-enum';
import styles from '../styles';

const daysOptions = Object.values(DaysOfWeek).map(({ shortName, abbrevName }) => ({
  label: abbrevName,
  value: shortName,
}));

const propTypes = {
  squared: PropTypes.bool,
  onPress: PropTypes.func.isRequired,
  optStyles: PropTypes.shape({}),
  selectedDays: PropTypes.arrayOf(PropTypes.string),
};
const defaultProps = {
  squared: false,
  selectedDays: undefined,
  optStyles: {},
};

const DayFilter = ({ optStyles, onPress, selectedDays, squared }) => {
  const { width: layoutWidth } = useWindowDimensions();
  const breakpointMet = layoutWidth > 500;

  const [selected, setSelected] = useSelectedParams([], onPress);

  const currentDays = selectedDays || selected;

  return (
    <View style={styles.container}>
      <View style={[styles.row, optStyles]}>
        {daysOptions.map(({ label, value }) => {
          const text = squared && breakpointMet ? label : value;
          return (
            <Button
              key={text}
              value={text}
              variant="outline"
              style={styles.button}
              pressed={currentDays.includes(value)}
              onPress={() => setSelected(value)}
              circular={!squared}
              thin={squared}
              fullWidth={squared}
            />
          );
        })}
      </View>
    </View>
  );
};

DayFilter.propTypes = propTypes;
DayFilter.defaultProps = defaultProps;

export default DayFilter;
